var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisabledPeopleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05448 4.86912C10.2763 4.86912 11.2654 3.98185 11.2654 2.87639C11.2654 1.77094 10.2763 0.883667 9.05448 0.883667C7.83266 0.883667 6.84357 1.77094 6.84357 2.87639C6.85811 3.98185 7.8472 4.86912 9.05448 4.86912Z",
    fill: "#C0C8D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4726 16.1418C11.8908 17.9745 10.0145 19.3272 7.789 19.3272C5.09809 19.3272 2.90173 17.349 2.90173 14.9345C2.90173 13.1454 4.109 11.589 5.81082 10.9054V9.04358C3.01809 9.79994 0.952637 12.1418 0.952637 14.9199C0.952637 18.309 4.00718 21.0727 7.77445 21.0727C10.5235 21.0727 12.8799 19.6036 13.9708 17.4945L13.1999 16.1272C12.9817 16.1272 12.7345 16.1418 12.4726 16.1418Z",
    fill: "#C0C8D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9018 18.4982L15.9491 13.2619C15.7309 12.8691 15.28 12.6219 14.8 12.6219H11.0182V11.8364H14.2764C14.5964 11.8364 14.8727 11.6764 15.0473 11.4582C15.1636 11.3128 15.2509 11.1528 15.2509 10.9491C15.2509 10.4691 14.8145 10.0764 14.2764 10.0764H12.3127H11.0182V7.45822C11.0182 6.73095 10.4218 5.71277 9.06908 5.71277C7.99272 5.71277 7.12 6.49822 7.12 7.45822V13.1746C7.12 14.1637 8.00727 14.9637 9.09818 14.9637H12.6618H14L16.5891 19.5601C16.8218 19.9673 17.2727 20.2001 17.7382 20.2001C17.9418 20.2001 18.1309 20.1564 18.32 20.0691C18.9745 19.7782 19.2218 19.0801 18.9018 18.4982Z",
    fill: "#C0C8D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledPeopleIcon);
export default __webpack_public_path__ + "static/media/disabled_people_icon.713bc7593f2ed37ea4ea744e18b9d1b3.svg";
export { ForwardRef as ReactComponent };